import { format } from 'date-fns';
import { NumberUtils } from 'modules';

export const dataDefined = {
  transaction: {
    label: 'Thông tin giao dịch',
    value: [
      {
        key: 'orderCode',
        label: 'Mã đơn hàng',
      },
      {
        key: 'transactionCode',
        label: 'Mã giao dịch',
      },
      {
        key: 'transactionType',
        label: 'Loại dịch vụ',
      },
      {
        key: 'period',
        label: 'Kỳ tháng',
        format: (data: string) => {
          const month = String(data)?.slice?.(4, 6) || '';
          const year = String(data)?.slice?.(0, 4) || '';
          return `${month}/${year}`;
        },
      },
      {
        key: 'value',
        label: 'Số tiền',
        format: (data: number) => NumberUtils.toCurrency(data),
      },
      {
        key: 'status',
        label: 'Trạng thái',
      },
      {
        key: 'payAt',
        label: 'Thời gian thanh toán',
        format: (data: string) =>
          data ? format(new Date(data), 'HH:mm:ss dd/MM/yyyy') : '',
      },
      {
        key: 'requestCancelAt',
        label: 'Thời gian gửi yêu cầu hủy',
        format: (data: string) =>
          data ? format(new Date(data), 'HH:mm:ss dd/MM/yyyy') : '',
      },
      {
        key: 'approvedCancelAt',
        label: 'Thời gian duyệt yêu cầu hủy',
        format: (data: string) =>
          data ? format(new Date(data), 'HH:mm:ss dd/MM/yyyy') : '',
      },
      {
        key: 'completedCancelAt',
        label: 'Thời gian hủy thành công',
        format: (data: string) =>
          data ? format(new Date(data), 'HH:mm:ss dd/MM/yyyy') : '',
      },
    ],
  },

  execBy: {
    label: 'Thông tin người thực hiện',
    value: [
      {
        key: 'fullName',
        label: 'Tên tài khoản',
      },
      {
        key: 'phoneNumber',
        label: 'Tài khoản',
        format: (data: string) => data?.replace('+84', '0') || '',
      },
      {
        key: 'leaderFullName',
        label: 'Tên trưởng nhóm',
      },
      {
        key: 'leaderPhoneNumber',
        label: 'SĐT trưởng nhóm',
        format: (data: string) => data?.replace('+84', '0') || '',
      },
      {
        key: 'pc',
        label: 'PC',
      },
      {
        key: 'agency',
        label: 'Điện lực',
      },
    ],
  },

  customer: {
    label: 'Thông tin khách hàng',
    value: [
      {
        key: 'customerCode',
        label: 'Mã khách hàng',
      },
      {
        key: 'fullName',
        label: 'Tên khách hàng',
      },
      {
        key: 'address',
        label: 'Địa chỉ',
      },
    ],
  },
};
